import React, { FC } from "react";
import Drawer from "shared/components/Drawer";
import { useFaqGroupPage } from "../../context";
import ActionButtons from "./components/ActionButtons";
import Tabs from "./components/Tabs";
import General from "./components/Tabs/Content/General";
import Translations from "./components/Tabs/Content/Translations";
import { FaqGroupDetailsProvider, useFaqGroupDetails } from "./context";
import { FaqGroupDetailsTabs } from "./context/types";
import GroupDetailsSkeleton from "./skeleton";

const FaqGroupDetailsContainer: FC = () => (
  <FaqGroupDetailsProvider>
    <FaqGroupDetails />
  </FaqGroupDetailsProvider>
);

const FaqGroupDetails: FC = () => {
  const { faqGroupDrawer } = useFaqGroupPage();
  const { onCloseFaqGroupDetails, isLoading, selectedTab } =
    useFaqGroupDetails();

  const TAB_CONTENT: Record<FaqGroupDetailsTabs, FC> = {
    [FaqGroupDetailsTabs.General]: General,
    [FaqGroupDetailsTabs.Translations]: Translations,
  };
  const ContentComponent = TAB_CONTENT[selectedTab];

  const title = faqGroupDrawer.drawerDetails ? "Edit group" : "Add new group";

  return (
    <Drawer
      title={title}
      isOpen={faqGroupDrawer.isOpen}
      onCloseDrawer={onCloseFaqGroupDetails}
      headingRight={<ActionButtons />}
      headingBottom={<Tabs />}
    >
      {isLoading && <GroupDetailsSkeleton />}
      {!isLoading && <ContentComponent />}
    </Drawer>
  );
};

export default FaqGroupDetailsContainer;
